var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"page-header-index-wide"},[_vm._t("default",[_c('router-view',{ref:"content"})])],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }